export function Footer() {
  return (
    <footer className="text-center py-4 text-[10px] text-sand-400">
      <span className="text-vibe-500 font-semibold">vibration</span> &copy; 2025 &middot; About &middot; Privacy &middot; Terms &middot; Help
    </footer>
  );
}
